import { Button, Col, Row, Table } from 'react-bootstrap';
import styles from '../../../../styles/incidents.module.css';
import { Controller, useFieldArray, useForm } from 'react-hook-form';
import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMultiply, faPlus, faTrashCan } from '@fortawesome/free-solid-svg-icons';
import ButtonOverride from '../../../../components/buttonoverride';
import { yupResolver } from '@hookform/resolvers/yup';
import FormInputValidationMessage from '../../../../components/forminputvalidationmessage';
import { buildIncidentNotificationValidationSchema } from './incident-validation';

const IncidentNotificationsAdd = ({item = null,toggleViewNotifications,notificationTypes, onSubmitFn}) => {


    const _hasFollowup = (id) => {
        const selectedObject = notificationTypes.find(option => option.id === id);

        return selectedObject ? selectedObject.hasfollowup : null
    }

    const validationSchema = buildIncidentNotificationValidationSchema(notificationTypes);

    const initialValues = {
        id: null,
        reportedTo: '',
        reportedToOther: '',
        comments: '',
        reportTime: '',
        rptDate: ''
    }

    const {control,handleSubmit,register,watch,setValue,trigger,formState: {errors,isDirty}} = useForm({defaultValues: item === null
        ? initialValues
        : item,
        resolver: yupResolver(validationSchema)});
    const selectFieldValue = watch('reportedTo');
    const txtOtherValue = watch('reportedToOther');
    
    const onSubmit = (data) => {
        const returnObj = {
            ...data,
            reportTime: data.reportTime === '' ? null : data.reportTime,
            reportedToOther: data.reportedToOther === '' ? null : data.reportedToOther,
            rptDate: data.rptDate === '' ? null : data.rptDate
        }
        onSubmitFn(returnObj);
    };

    useEffect(() => {
        // Trigger validation when selectField changes
        if(!_hasFollowup(selectFieldValue)){
            setValue('reportedToOther','');
        }

        trigger('reportedToOther');
    }, [selectFieldValue, trigger]);

    useEffect(() => {

        trigger('reportedToOther');
    }, [txtOtherValue, trigger]);
    return(
        <>
            <div className={styles.notificationsHeader}>
                <h5 className='fw-bold me-1 mb-0'>
                    Add Notification
                </h5>
            </div>
            <div className={styles.notificationsBody}>
                <Row className='ms-0 me-0'>
                    <Col xs={12} md={6}>
                    {/* <Controller
                        name='notificationto'
                        control={control}
                        render={({field}) => (
                            <div className={styles.inputCol}>
                                <label htmlFor='notificationto'>Reported To</label>
                                <select id='notificationto' style={{width: '100%',height: '30px'}} onChange={(e) => field.onChange(+e.target.value)}>
                                    <option value={-1} disabled>--Please Make a selection--</option>
                                    {
                                        notificationTypes.map((item) => (
                                            <option key={item.id} value={item.id}>{item.name}</option>
                                        ))
                                    }
                                </select>
                            </div>
                    )}
                    /> */}
                        <div className={styles.inputCol}>
                                <label htmlFor='reportedTo'>Reported To</label>
                                <select id='reportedTo' style={{width: '100%',height: '30px'}} {...register("reportedTo")}>
                                    <option value='' disabled>--Please Make a selection--</option>
                                    {
                                        notificationTypes.map((item) => (
                                            <option key={item.id} value={item.id}>{item.name}</option>
                                        ))
                                    }
                                </select>
                            </div>
                    <FormInputValidationMessage error={errors.reportedTo} />
                        {/* <ValidatedInput type='select' label='Reported To' name="notificationto" style={{width: '100%',height: '30px'}} onValueChange={updateValue}/> */}
                    </Col>
                    <Col xs={12} md={6}>
                        <label htmlFor='reportedToOther'>Other</label>
                        <input id='reportedToOther' autoComplete='off' type='text' style={{width: '100%',height: '30px'}} {...register("reportedToOther")} disabled={!_hasFollowup(selectFieldValue)}/>
                        <FormInputValidationMessage error={errors.reportedToOther} />
                    </Col>
                    <Col xs={12}>
                        <label htmlFor='comments'>Comments</label>
                        <textarea id='comments' {...register("comments")} rows={3} style={{width: '100%'}} autoComplete='off'/>
                        <FormInputValidationMessage error={errors.comments} />
                        {/* <ValidatedInput type='textarea' label='Comments' name='notificationcomments' value={formValues.notificationcomments} style={{width: '100%'}} rows={4} onValueChange={updateValue}/> */}
                    </Col>
                    <Col xs={12} md={6}>
                        <label htmlFor='reportTime'>Date/Time</label>
                        <input type='datetime-local' {...register('reportTime')} max={new Date().toISOString()} id='reportTime' style={{width: '100%'}}/>
                        <FormInputValidationMessage error={errors.reportTime} />
                        {/* <ValidatedInput type='datetime-local' label='Date/Time' name='notificationdt' style={{width: '100%'}} onValueChange={updateValue}/> */}
                    </Col>
                    <Col xs={12} md={6}>
                        <label htmlFor='rptDate'>Final Report Date</label>
                        <input type='date' {...register('rptDate')} max={new Date().toISOString()} id='rptDate' style={{width: '100%'}}/>
                        <FormInputValidationMessage error={errors.rptDate} />
                    </Col>
                </Row>
            </div>
            <div className={styles.notificationsFooter}>
                <Button type='button' variant='danger' onClick={toggleViewNotifications}>Cancel</Button>
                <Button type='submit' variant={item === null ? 'success' : 'primary'} onClick={handleSubmit(onSubmit)} disabled={!isDirty}>
                    {
                        item !== null
                        ?
                            <>Save Changes</>
                        :
                            <>Add Notification</>
                    }
                </Button>
            </div>
        </>
    )
}

export default IncidentNotificationsAdd;
